import { useState, useEffect } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { unwrapResult } from '@reduxjs/toolkit'
import { getCallTrackingProviders } from '@user/store/callTracking/api'
import { ICallTrackingProvider } from '@user/store/callTracking/typings'

export const useGetCallTrackingProviders = () => {
  const dispatch = useAppDispatch()

  const [status, setStatus] = useState<'pending' | 'success' | 'fail'>(
    'pending',
  )

  const [callTrackingProviders, setCallTrackingProviders] = useState<
    ICallTrackingProvider[]
  >([])

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      try {
        setStatus('pending')

        const result = await dispatch(getCallTrackingProviders())

        if (mounted) {
          if (getCallTrackingProviders.fulfilled.match(result)) {
            setCallTrackingProviders(unwrapResult(result))
            setStatus('success')
          } else {
            setStatus('fail')
          }
        }
      } catch {
        if (mounted) {
          setStatus('fail')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch])

  return { callTrackingProviderStatus: status, callTrackingProviders }
}
